import { startStimulusApp } from '@symfony/stimulus-bridge';
import '@symfony/ux-live-component';

import emptyContext from './stimulus/empty-context';
import registerLazy from './stimulus/register-lazy';
import registerSharedControllers from './stimulus/shared-controllers';

/**
 * Entrée JS du site public.
 *
 * Les contrôleurs sont enregistrés nommément, et non découverts par `require.context` : le dossier
 * `assets/controllers/` sert les quatre espaces (public, onboarding, client, back-office), et tout
 * ce qui y est découvert finit dans le bundle. Une page publique n'a rien à faire du parcours de
 * souscription ou du graphe de valorisation — d'où une liste explicite par entrée, au prix d'un
 * enregistrement à ajouter quand un nouveau contrôleur apparaît dans un gabarit public.
 *
 * L'application ne démarre donc qu'avec les paquets UX de `assets/controllers.json` (cf.
 * stimulus/empty-context.ts), auxquels s'ajoutent les enregistrements ci-dessous.
 *
 * @see stimulus/shared-controllers.ts pour ce que cette entrée partage avec `account.ts`
 */
const application = startStimulusApp(emptyContext);

registerSharedControllers(application);

// public/pages/simulation-financiere/simulateur-{epargne,mensualites}-assurance-vie — katex
registerLazy(application, 'simulateur--formula', () => import('./controllers/simulateur/formula-controller'));

export { application };
